'use strict';
var dispatcher = require('./dispatcher'),
    Store = require('./store'),
    createComponent = require('./component/create'),
    ImmobiliareFlux = {};

ImmobiliareFlux.Store = Store;
ImmobiliareFlux.dispatcher = dispatcher;
ImmobiliareFlux.createComponent = createComponent;

ImmobiliareFlux.render = function (Component, props, opt) {
    var component = new Component(props, opt);

    component.doRender();
    return component;
};

ImmobiliareFlux.mount = function (Component, el, props, opt) {
    var component = new Component(props, opt);

    component.doMount(el);
    return component;
};

module.exports = ImmobiliareFlux;
